import { useCallback, useEffect } from "react"
import { useDispatch } from "react-redux"
import { APIAuthenticationType } from "../Actions/Types"
import {
    selectUser,
    selectHasFreemiumExpired
} from "../Helpers/Functions/Selectors/auth"
import { calculateFreemiumPlanExpiry, UserPlan } from "../Models/API/UserModel"
import { useAppState } from "./useReduxState"
import { useUserPlan } from "./useUserPlan"

/**
 *
 * calculates number of days for the plan to expire if FREEMIUM user, else undefined
 */
export const useFreemiumExpiryCountdown = (): void => {
    const dispatch = useDispatch()
    const userPlan = useUserPlan()
    const user = useAppState(selectUser)
    const hasFreemiumPlanExpired = useAppState(selectHasFreemiumExpired)
    const calculateUserExpiry = useCallback(
        () =>
            dispatch({
                type: APIAuthenticationType.setFreemiumPlanExpiryDays,
                payload: calculateFreemiumPlanExpiry(user)
            }),
        [dispatch, user]
    )

    useEffect(() => {
        calculateUserExpiry()
    }, [calculateUserExpiry])

    useEffect(() => {
        if (!hasFreemiumPlanExpired && userPlan !== UserPlan.FULL) {
            const id = setInterval(calculateUserExpiry, 60 * 30 * 1000)
            return () => clearInterval(id)
        }
    }, [calculateUserExpiry, hasFreemiumPlanExpired, userPlan])
}
